import React, { createContext, useState } from 'react';

const AuthContextClient = createContext();

const AuthProviderClient = ({ children }) => {
  const [clientUser, setClientUser] = useState(
    localStorage.getItem('clientUser') || ''
  );

  const [error, setError] = useState(null);

  const clientLogin = async (password) => {
    const clientPassword = process.env.REACT_APP_CLIENT_PASSWORD;

    if (password === clientPassword) {
      try {
        setClientUser(true);
        localStorage.setItem('clientUser', true);
        setError(null);
      } catch (error) {
        setError(error.message);
      }
    } else {
      setError('Incorrect password');
    }
  };

  const logoutClient = () => {
    setClientUser(null);
    localStorage.removeItem('clientUser');
    setError(null);
  };

  const clearError = () => setError(null);

  return (
    <AuthContextClient.Provider
      value={{
        userClient: clientUser,
        clientLogin,
        logoutClient,
        error,
        clearError,
      }}
    >
      {children}
    </AuthContextClient.Provider>
  );
};

export { AuthProviderClient, AuthContextClient };
